class SmoothScroll {

	constructor() {
		smoother = ScrollSmoother.create({
			content: "#content",
			wrapper: "#viewport"
		});
	}
}
